import { ProgressSpinner } from "primereact/progressspinner";
import React from "react";

export const Loader = () => {
	return (
		<div
			style={{
				position: "fixed",
				top: 0,
				left: 0,
				width: "100vw",
				height: "100vh",
				display: "flex",
				flexDirection: "column",
				alignItems: "center",
				justifyContent: "center",
				gap: "1rem",
				backgroundColor: "rgba(255, 255, 255, 0.6)",
				zIndex: 9999,
			}}
		>
			<ProgressSpinner style={{ width: "48px", height: "48px" }} strokeWidth="4" />
			<div style={{ fontSize: "1.25rem" }}>Lädt...</div>
		</div>
	);
};
